/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

import React from 'react';

// $FlowFixMe Update Flow
export default React.createContext({
  banner: null,
  dismiss() {},
});
